(function () {
  'use strict';

  if (window.__measurementTableModalLoaded) return;
  window.__measurementTableModalLoaded = true;

  const MODAL_ID = 'measurement-table-modal';
  const BTN_ID = 'measurement-table-trigger';

  function findMeasurementBlock(root) {
    if (!root) return null;

    // KZK CSV converter marker class'i
    const markerEl = root.querySelector('.kzk-measurement-table');
    if (markerEl && markerEl.querySelector('table')) return markerEl;

    const headings = root.querySelectorAll('h2, h3, h4, h5, strong, b');
    for (const h of headings) {
      const t = (h.textContent || '').trim().toLowerCase();
      if (
        t.startsWith('olcu tablosu') ||
        t.startsWith('ölçü tablosu') ||
        t.startsWith('size table') ||
        t.startsWith('size chart') ||
        t.startsWith('measurement')
      ) {
        const wrapper = h.closest('div');
        if (wrapper && wrapper.querySelector('table')) return wrapper;
        const next = h.nextElementSibling;
        if (next && next.tagName === 'TABLE') {
          const div = document.createElement('div');
          div.appendChild(h.cloneNode(true));
          div.appendChild(next.cloneNode(true));
          return div;
        }
      }
    }
    return null;
  }

  function findProductDescription() {
    const selectors = [
      // KZK theme: <details-disclosure> > .disclosure__content.rte
      '[data-dynamic-product-content$="-content"]',
      '.disclosure__content.rte',
      '.disclosure__content',
      // Diger temalar
      '.product__description',
      '.wt-product__description',
      '.product-description',
      '.product-info__description',
      '[data-product-description]',
      '.product-single__description',
      // En son fallback (tum .rte tarayicisi)
      '.rte'
    ];
    for (const sel of selectors) {
      const els = document.querySelectorAll(sel);
      for (const el of els) {
        if (el.querySelector('table')) return el;
      }
    }
    return null;
  }

  function findActionButtonsContainer() {
    const selectors = [
      '.product-form__buttons',
      '.product-info__add-to-cart',
      '.product-form',
      '.product-info__action-buttons',
      'product-form'
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function buildModal() {
    if (document.getElementById(MODAL_ID)) return document.getElementById(MODAL_ID);
    const overlay = document.createElement('div');
    overlay.id = MODAL_ID;
    overlay.className = 'mtm-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'mtm-title');
    overlay.innerHTML = `
      <div class="mtm-modal" role="document">
        <div class="mtm-header">
          <h3 id="mtm-title" class="mtm-title">Ölçü Tablosu</h3>
          <button type="button" class="mtm-close" aria-label="Kapat">&times;</button>
        </div>
        <div class="mtm-body"></div>
      </div>
    `;
    document.body.appendChild(overlay);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });
    overlay.querySelector('.mtm-close').addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('mtm-open')) closeModal();
    });
    return overlay;
  }

  function openModal() {
    const overlay = document.getElementById(MODAL_ID);
    if (!overlay) return;
    overlay.classList.add('mtm-open');
    document.body.classList.add('mtm-no-scroll');
  }
  function closeModal() {
    const overlay = document.getElementById(MODAL_ID);
    if (!overlay) return;
    overlay.classList.remove('mtm-open');
    document.body.classList.remove('mtm-no-scroll');
  }

  function buildTriggerButton() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.id = BTN_ID;
    btn.className = 'mtm-trigger-btn';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="6" width="18" height="12" rx="1"/>
        <line x1="7" y1="6" x2="7" y2="9"/>
        <line x1="11" y1="6" x2="11" y2="10"/>
        <line x1="15" y1="6" x2="15" y2="9"/>
        <line x1="19" y1="6" x2="19" y2="10"/>
      </svg>
      <span>Ölçü Tablosu</span>
    `;
    btn.addEventListener('click', openModal);
    return btn;
  }

  function findAllMeasurementBlocks() {
    // Tum sayfada (richtext, description accordion, vs.) olcu tablolarini bul
    const blocks = [];
    const seen = new Set();

    // 1. Marker class
    document.querySelectorAll('.kzk-measurement-table').forEach(el => {
      if (!seen.has(el) && el.querySelector('table')) {
        blocks.push(el);
        seen.add(el);
      }
    });

    // 2. Heading bazli arama (tum sayfada)
    const headings = document.querySelectorAll('h2, h3, h4, h5, strong, b');
    for (const h of headings) {
      const t = (h.textContent || '').trim().toLowerCase();
      if (
        t.startsWith('olcu tablosu') ||
        t.startsWith('ölçü tablosu') ||
        t.startsWith('size table') ||
        t.startsWith('size chart') ||
        t.startsWith('measurement')
      ) {
        const wrapper = h.closest('div');
        if (wrapper && wrapper.querySelector('table') && !seen.has(wrapper)) {
          blocks.push(wrapper);
          seen.add(wrapper);
        }
      }
    }
    return blocks;
  }

  function init() {
    const isProductPage = document.body.classList.contains('template-product') ||
      document.querySelector('[data-product-id], .product-info, .product-template, .wt-product__main');
    if (!isProductPage) return;

    const allBlocks = findAllMeasurementBlocks();
    if (!allBlocks.length) return;

    // Ilkini modal'a kopyala, hepsini gizle
    const measBlock = allBlocks[0];

    const overlay = buildModal();
    const body = overlay.querySelector('.mtm-body');
    body.innerHTML = '';
    const cloned = measBlock.cloneNode(true);
    // Modal icindeki kopyada display:none inline style'i kaldir, gorunsun
    cloned.style.cssText = '';
    cloned.removeAttribute('hidden');
    body.appendChild(cloned);

    // Tum olcu tablosu instance'larini gizle (richtext + description accordion vb.)
    allBlocks.forEach(b => {
      b.style.cssText = 'display: none !important;';
      b.setAttribute('data-mtm-extracted', '1');
    });

    const cleanupHeading = body.querySelector('h2, h3, h4, h5');
    if (cleanupHeading && /tablosu|table|chart|measurement/i.test(cleanupHeading.textContent)) {
      cleanupHeading.style.display = 'none';
    }

    if (document.getElementById(BTN_ID)) return;
    const container = findActionButtonsContainer();
    const trigger = buildTriggerButton();
    if (container) {
      container.parentNode.insertBefore(trigger, container.nextSibling);
    } else {
      // Fallback: ilk block'un yanina
      measBlock.parentNode.insertBefore(trigger, measBlock);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let attempts = 0;
  const observer = new MutationObserver(() => {
    if (document.getElementById(BTN_ID)) {
      observer.disconnect();
      return;
    }
    attempts++;
    if (attempts > 20) {
      observer.disconnect();
      return;
    }
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 8000);
})();
